import {initSlider} from './section.slider';
import {initFirstScreen} from './section.first-screen';
import {initSliderWithText} from './section.slider-with-text';
import {initGallery} from './section.gallery';
import {initApartmentCard} from './section.apartment-card';
import {initHeader} from './header';
import {initFooter} from './footer';
import {initChooser} from './section.chooser';
import {initContacts} from './section.contacts';
import {initStylizedMap} from './section.stylized-map';

export const initComponents = () => {
	initSlider();
	initFirstScreen();
	initSliderWithText();
	initHeader();
	initFooter();
	initGallery();
	initChooser();
	initApartmentCard();
	initContacts();
	initStylizedMap();
};
